// @ts-nocheck
import React, { Component } from "react";
import { CommonNav } from "../CommonNav";

export class SecondaryNav extends Component {
  render() {
    const menuItems = [
      {
        path: "/controllers/add-license",
        title: "Add New License"
      },
      {
        path: "/controllers/licenses",
        title: "Manage Licenses"
      },
      {
        path: "/controllers/security-config",
        title: "Security Config"
      },
      {
        path: "/controllers/change-password",
        title: "Change Password"
      },
      {
        path: "/controllers/daemon-settings",
        title: "Daemon Settings"
      }
    ];

    return <CommonNav navItems={menuItems} />;
  }
}
